export const DEFAULT_PAGE_SIZE = 12;
//# sourceMappingURL=pagination.js.map